export const menuData = [
    {
        id: "antipasti",
        title: "",
        sections: [
            {
                id: "antipasti-piatti-unici",
                title: "Antipasti e Piatti unici",
                items: [
                    {
                        name: "Antipasto Mare",
                        description: "Totani, seppie, polpo, cozze, alici, crostini, carpaccio spada.",
                        price: "14,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Antipasto Toscano",
                        description: "Salumi, formaggi, crostini, ………",
                        price: "12,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Tris Carpaccio Mare",
                        description: "Pesce spada, tonno, salmone, rucola, pomodori",
                        price: "12,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Carpaccio di Bresaola",
                        description: "Bresaola, rucola, parmigiano, pomodorini",
                        price: "9,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Impepata di Cozze",
                        description: "Cozze, aglio, prezzemolo, pepe",
                        price: "10,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Crostini Misti",
                        description: "Pane, patè fegatini, pomodoro, patè radicchio/cipolla/funghi.",
                        price: "7,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Pappa di Mare",
                        description: "Pane, pomodoro, totano, seppia, cozze",
                        price: "10,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Tartare Cipolla Caramellata",
                        description: "Manzo, cipolla, aromi",
                        price: "10,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Insalata Mare",
                        description: "Totani, seppie, polpo, cozze, gamberi, carote, zucchine",
                        price: "12,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Uovo Purgatorio",
                        description: "Uovo, pomodoro, basilico, parmigiano, peperoncino",
                        price: "8,00 €",
                        tags: ["vegetariana", "piccante"]
                    },
                    {
                        name: "Insalatona Mista",
                        description: "Insalata mista, pomodoro, cetriolo, mais, carote, olive",
                        price: "8,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Antipasto Vegetariano",
                        description: "Verdure grigliate, formaggi, pomodorini, bruschette, ………",
                        price: "12,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Insalata Papavero",
                        description: "Insalata verde, prosc. crudo, rucola, pomodorini, semi di papavero",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Insalata Estate",
                        description: "Insalata mista, tonno, mozzarella, olive",
                        price: "8,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Insalata Buscavida",
                        description: "Insalata mista, pollo, pomodorini, parmigiano, olive",
                        price: "8,00 €",
                        tags: ["carne"]
                    }
                ]
            }
        ]
    },
    {
        id: "cucina",
        title: "",
        sections: [
            {
                id: "primi",
                title: "Primi",
                items: [
                    {
                        name: "Spaghetto Scoglio",
                        description: "Totani, seppie, polpo, cozze, vongole",
                        price: "15,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Ravioli di Burrata al Ragù",
                        description: "Raviolo, aromi",
                        price: "14,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Penne Scampi",
                        description: "Pasta, pomodoro, scampi, panna",
                        price: "15,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Gnocchetti Buscavida",
                        description: "Gnocchi di patate, melanzane, pomodorini, pesto basilico, formaggio cremoso",
                        price: "13,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Riso Pescatora",
                        description: "Pomodoro, totani, seppie, polpo, cozze.",
                        price: "15,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Riso al Cavolo Viola",
                        description: "Riso, cavolo viola, cipolla, guanciale",
                        price: "12,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Pasta al Ragù",
                        description: "Manzo, cipolla, aromi",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Pasta al Pomodoro",
                        description: "pomodoro",
                        price: "8,00 €",
                        tags: ["vegetariana"]
                    }
                ]
            },
            {
                id: "secondi",
                title: "Secondi",
                items: [
                    {
                        name: "Baccalà alla Livornese",
                        description: "Baccalà fritto, pomodoro, aglio, prezzemolo, peperoncino",
                        price: "14,00 €",
                        tags: ["pesce", "piccante"]
                    },
                    {
                        name: "Peposo con Purè",
                        description: "Manzo, vino rosso, aromi, pepe, patate",
                        price: "14,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Frittura di Pesce",
                        description: "Calamari, gamberetti",
                        price: "16,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Tagliata Rucola e Parmigiano",
                        description: "Carne di manzo, rucola, parmigiano",
                        price: "18,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Pesce al Forno con Verdure",
                        description: "Pesce (orata/spigola), verdure",
                        price: "20,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Tagliata Rosmarino Scalogno e Lardo",
                        description: "Carne di manzo, aromi, lardo",
                        price: "18,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Gamberoni Guazzetto",
                        description: "",
                        price: "18,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Cotoletta Pollo e Patate",
                        description: "",
                        price: "8,00 €",
                        tags: ["carne"]
                    }
                ]
            },
            {
                id: "contorni",
                title: "Contorni",
                items: [
                    {
                        name: "Patate Fritte",
                        description: "",
                        price: "5,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Patate Arrosto",
                        description: "",
                        price: "5,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Insalata Mista",
                        description: "",
                        price: "5,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Insalata Mista con Pomodori",
                        description: "",
                        price: "5,00 €",
                        tags: ["vegetariana"]
                    }
                ]
            }
        ]
    },
    {
        id: "pizzeria",
        title: "",
        sections: [
            {
                id: "classiche",
                title: "Pizze classiche",
                items: [
                    {name: "Margherita", description: "Pomodoro, mozzarella", price: "7,00 €", tags: ["vegetariana"]},
                    {name: "Napoli", description: "Pomodoro, mozzarella, capperi, acciughe", price: "7,50 €", tags: ["pesce"]},
                    {
                        name: "Salamino piccante",
                        description: "Pomodoro, mozzarella, salamino piccante",
                        price: "7,50 €",
                        tags: ["carne", "piccante"]
                    },
                    {
                        name: "Salame toscano",
                        description: "Pomodoro, mozzarella, salame toscano",
                        price: "7,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Prosciutto cotto",
                        description: "Pomodoro, mozzarella, prosciutto cotto",
                        price: "7,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Prosciutto crudo",
                        description: "Pomodoro, mozzarella, prosciutto crudo",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Boscaiola",
                        description: "Pomodoro, mozzarella, funghi, salsiccia, aglio, prezzemolo, olive",
                        price: "9,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Marinara",
                        description: "Pomodoro, mozzarella, aglio, prezzemolo",
                        price: "6,50 €",
                        tags: ["vegetariana"]
                    },
                    {name: "Wurstel", description: "Pomodoro, mozzarella, wurstel", price: "7,50 €", tags: ["carne"]},
                    {name: "Cipolla", description: "Pomodoro, mozzarella, cipolla", price: "7,50 €", tags: ["vegetariana"]},
                    {name: "Funghi", description: "Pomodoro, mozzarella, funghi", price: "7,50 €", tags: ["vegetariana"]},
                    {name: "Salsiccia", description: "Pomodoro, mozzarella, salsiccia", price: "7,50 €", tags: ["carne"]},
                    {
                        name: "Salsiccia e cipolla",
                        description: "Pomodoro, mozzarella, salsiccia, cipola",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                    {name: "Tonno", description: "Pomodoro, mozzarella, tonno", price: "7,50 €", tags: ["pesce"]},
                    {
                        name: "Tonno e cipolla",
                        description: "Pomodoro, mozzarella, tonno, cipolla",
                        price: "8,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Prosciutto crudo e funghi",
                        description: "Pomodoro, mozzarella, funghi, prosciutto crudo",
                        price: "8,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Prosciutto cotto e funghi",
                        description: "Pomodoro, mozzarella, funghi, prosciutto cotto",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Capricciosa",
                        description: "Pomodoro, mozzarella, funghi, carciofi, wurstel, salame piccante, prosciutto cotto",
                        price: "8,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Quattro stagioni",
                        description: "Pomodoro, mozzarella, funghi, carciofi, wurstel, olive, prosciutto cotto",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Calzone Napoli",
                        description: "Mozzarella, salamino piccante, ricotta, pomodoro a crudo",
                        price: "8,50 €",
                        tags: ["carne", "piccante", "calzone"]
                    },
                    {
                        name: "Calzone farcito",
                        description: "Mozzarella, funghi, carciofi, wurstel, olive salamino piccante, prosciutto cotto, pomodoro a crudo",
                        price: "8,50 €",
                        tags: ["carne", "calzone"]
                    },
                    {
                        name: "Calzone",
                        description: "Mozzarella, prosciutto cotto, pomodoro a crudo",
                        price: "7,50 €",
                        tags: ["carne", "calzone"]
                    },
                    {
                        name: "Calzone prosciutto e funghi",
                        description: "Mozzarella, funghi, prosciutto cotto, pomodoro a crudo",
                        price: "8,00 €",
                        tags: ["carne", "calzone"]
                    },
                ],
            },
            {
                id: "bianche",
                title: "Pizze bianche",
                items: [
                    {name: "Biancaneve", description: "Mozzarella", price: "7,00 €", tags: ["vegetariana", "bianca"]},
                    {
                        name: "Bianca fiori di zucca",
                        description: "Mozzarella, fiori di zucca, acciughe",
                        price: "8,50 €",
                        tags: ["pesce", "bianca"]
                    },
                    {
                        name: "Tartufata semplice",
                        description: "Mozzarella, tartufo, parmigiano a scaglie",
                        price: "8,00 €",
                        tags: ["vegetariana", "bianca"]
                    },
                    {
                        name: "Carbonara",
                        description: "Mozzarella, guanciale, pecorino romano, uovo, pepe",
                        price: "10,00 €",
                        tags: ["carne", "bianca"]
                    },
                    {
                        name: "Salmone gamberetti e panna",
                        description: "Mozzarella, salmone, gamberetti, panna",
                        price: "10,00 €",
                        tags: ["pesce", "bianca"]
                    },
                    {
                        name: "Golosa",
                        description: "Mozzarella, funghi porcini, olio tartufo, pomodoro ciliegino, pan grattato",
                        price: "10,00 €",
                        tags: ["vegetariana", "bianca"]
                    },
                    {
                        name: "Perlage al basilico",
                        description: "Mozzarella di bufala, perlage di basilico, acciughe, foglie di basilico",
                        price: "10,00 €",
                        tags: ["pesce", "bianca"]
                    },
                    {
                        name: "Formaggi bianca",
                        description: "Mozzarella, formaggi freschi",
                        price: "8,50 €",
                        tags: ["vegetariana", "bianca"]
                    },
                    {
                        name: "Gorgonzola noci e pere",
                        description: "Mozzarella, gorgonzola, noci, pere",
                        price: "9,50 €",
                        tags: ["vegetariana", "bianca"]
                    },
                    {
                        name: "Zingara",
                        description: "Mozzarella di bufala, peperoni, olive, capperi, pomodorini, origano",
                        price: "10,00 €",
                        tags: ["vegetariana", "bianca"]
                    },
                    {
                        name: "Piemontese",
                        description: "Mozzarella, salsiccia, olio tartufo, pepe, ricotta",
                        price: "9,00 €",
                        tags: ["carne", "bianca"]
                    },
                    {
                        name: "Montebianco",
                        description: "Mozzarella, formaggi freschi, funghi, acciughe",
                        price: "9,00 €",
                        tags: ["pesce", "bianca"]
                    },
                    {
                        name: "Cacio e Pepe",
                        description: "Mozzarella, pecorino romano, pepe in grani",
                        price: "8,50 €",
                        tags: ["vegetariana", "bianca"]
                    },
                    {
                        name: "Tartufata",
                        description: "Mozzarella di bufala, tartufo, funghi porcini, lardo",
                        price: "10,00 €",
                        tags: ["carne", "bianca"]
                    },
                    {
                        name: "Italia",
                        description: "Mozzarella, pomodoro a fette, rucola, parmigiano",
                        price: "8,50 €",
                        tags: ["vegetariana", "bianca"]
                    },
                    {
                        name: "Bianco sapore",
                        description: "Mozzarella, salmone, gamberetti, zucchine a julienne",
                        price: "10,00 €",
                        tags: ["pesce", "bianca"]
                    },
                    {
                        name: "Beata",
                        description: "Mozzarella di bufala, pesto di basilico, pomodori secchi, acciughe, olive",
                        price: "10,00 €",
                        tags: ["pesce", "bianca"]
                    },
                    {
                        name: "Primavera",
                        description: "Mozzarella di bufala, prosciutto crudo, parmigiano, pomodorini",
                        price: "9,50 €",
                        tags: ["carne", "bianca"]
                    },
                    {
                        name: "Mortadella e stracciatella",
                        description: "Mozzarella, mortadella, stracciatella, granella di noci",
                        price: "9,50 €",
                        tags: ["carne", "bianca"]
                    },
                    {
                        name: "Lemon pizza",
                        description: "Mozzarella di bufala, gamberi, salmone, limone infornato, scaglie di parmigiano, rucola",
                        price: "11,00 €",
                        tags: ["pesce", "bianca"]
                    },
                    {
                        name: "Polpo e patate",
                        description: "Mozzarella di bufala, carciofi, polpo e patate",
                        price: "11,00 €",
                        tags: ["pesce", "bianca"]
                    },
                ],
            },
            {
                id: "particolari",
                title: "Pizze speciali",
                items: [
                    {
                        name: "Mascarpone e crudo",
                        description: "Pomodoro, mozzarella, mascarpone, prosciutto crudo",
                        price: "8,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Delicata",
                        description: "Pomodoro, mozzarella, philadelphia, prosciutto crudo, rucola, pinoli",
                        price: "9,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Leggerezza",
                        description: "Pomodoro, mozzarella, pesto di basilico, parmigiano, pomodorini",
                        price: "8,50 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Sfiziosa",
                        description: "Pomodoro, mozzarella, gorgonzola, cipolla, salamino piccante",
                        price: "9,00 €",
                        tags: ["carne", "piccante"]
                    },
                    {
                        name: "Frutti di mare",
                        description: "Pomodoro, mozzarella, fruddi di mare, aglio, prezzemolo",
                        price: "10,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Vesuvio",
                        description: "Pomodoro, mozzarella, ricotta, salamino piccante",
                        price: "8,50 €",
                        tags: ["carne", "piccante"]
                    },
                    {
                        name: "Miami",
                        description: "Pomodoro, mozzarella, wurstel, patatine fritte",
                        price: "8,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Vegetariana",
                        description: "Pomodoro, mozzarella, carote, zucchine, melanzane, peperoni",
                        price: "8,50 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Conte",
                        description: "Pomodoro, acciughe, capperi, aglio, prezzemolo, salamino piccante",
                        price: "8,50 €",
                        tags: ["carne", "piccante"]
                    },
                    {
                        name: "Tre colori",
                        description: "Pomodoro, rucola belga, trevisana",
                        price: "8,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Mascarpone e Speck",
                        description: "Pomodoro, mozzarella, mascarpone, speck",
                        price: "8,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Valtellina",
                        description: "Pomodoro, mozzarella, bresaola, rucola, parmigiano a scaglie",
                        price: "8,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Saporita",
                        description: "Pomodoro, mozzarella, mascarpone, salsiccia, melanzane",
                        price: "9,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Bomba",
                        description: "Pomodoro, mozzarella, salamino piccante, salsiccia, olive, peperoncino",
                        price: "8,50 €",
                        tags: ["carne", "piccante"]
                    },
                    {name: "Salumeria", description: "Pomodoro, mozzarella, misto di salumi", price: "9,00 €", tags: ["carne"]},
                    {
                        name: "Bufalina",
                        description: "Pomodoro, mozzarella di bufala, pomodoro ciliegino, basilico",
                        price: "9,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Divina",
                        description: "Pomodoro, mozzarella, pesce spada, rucola",
                        price: "11,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Friarielli e Salsiccia",
                        description: "Pomodoro, mozzarella, friarielli, salsiccia",
                        price: "9,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Rosso Relativo",
                        description: "Pomodoro, bocconcini di bufala, pomodoro ciliegino, grana, peperoncino, basilico",
                        price: "11,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Rustica",
                        description: "Pomodoro, mozzarella, stracchino, salsiccia, trevisana",
                        price: "9,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Buio pesto",
                        description: "Pomodoro, ricotta, prosciutto crudo, pesto di basilico",
                        price: "9,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Busca Vida",
                        description: "Pomodoro, mozzarella, pollo grigliato sfilacciato, crema al formaggio",
                        price: "10,00 €",
                        tags: ["carne"]
                    },
                    {name: "Pecorino", description: "Pomodoro, mozzarella, pecorino", price: "7,50 €", tags: ["vegetariana"]},
                    {
                        name: "America",
                        description: "Pomodoro, mozzarella, tutto il possibile",
                        price: "10,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Semplicità",
                        description: "Pomodoro, mozzarella di bufala, bresaola, pesto di basilico, basilico",
                        price: "9,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Funghi Porcini",
                        description: "Pomodoro, mozzarella, funghi porcini",
                        price: "9,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Sardegna",
                        description: "Pomodoro, cipolla croccante, datterini gialli, filetti di tonno",
                        price: "10,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "5 formaggi freschi",
                        description: "Pomodoro, mozzarella, formaggi freschi",
                        price: "8,50 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Mortadella e pistacchio",
                        description: "Pomodoro, mozzarella., mortadella, crema di pistacchio, granella di pistacchi",
                        price: "9,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Tropicale",
                        description: "Pomodoro, mozzarella, ananas, prosciutto cotto",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                ],
            },
            {
                id: "schiacciatini",
                title: "Schiacciatini",
                items: [
                    {name: "Schiacciatino olio e sale", description: "olio, sale", price: "3,00 €", tags: ["vegetariana"]},
                    {
                        name: "Schiacciatino ripieno Pomo",
                        description: "Mozzarella, pomodoro fresco",
                        price: "7,00 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Schiacciatino ripieno Cotto",
                        description: "Mozzarella, prosciutto cotto",
                        price: "7,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Schiacciatino ripieno Crudo",
                        description: "Mozzarella, prosciutto crudo",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Schiacciatino saporito",
                        description: "Mozzarella, pomodoro fresco, prosciutto crudo, rucola",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Schiacciatino mortadellino",
                        description: "Mortadella, pomodoro ciliegino, pesto di basilico",
                        price: "7,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Schiacciatino carpaccino",
                        description: "Bresaola, rucola, grana a scaglie",
                        price: "7,50 €",
                        tags: ["carne"]
                    },
                    {name: "Schiacciatino affumicato", description: "Speck, emmental", price: "7,50 €", tags: ["carne"]},
                    {
                        name: "Schiacciatino marino",
                        description: "Carpaccio di spada, salmone, rucola e pomodoro ciliegino",
                        price: "9,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Schiacciatino fresco",
                        description: "Maionese, pomodoro fresco, tonno, insalata",
                        price: "8,00 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Schiacciatino farcito",
                        description: "Mozzarella, funghi, prosciutto cotto, sottoli misti",
                        price: "8,00 €",
                        tags: ["carne"]
                    },
                ],
            },
        ]
    },
    {
        id: "crostoni",
        title: "",
        sections: [
            {
                id: "crostoni",
                title: "Crostoni",
                items: [
                    {
                        name: "Crostone Acciughe",
                        description: "Pane, burrata, acciughe, lime",
                        price: "7,50 €",
                        tags: ["pesce"]
                    },
                    {
                        name: "Crostone Burrata",
                        description: "Pane, burrata, pesto basilico, pomodorini",
                        price: "7,50 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Crostone Piccante",
                        description: "Pane, mozzarella, salame picc., pomi secchi, melanzana, aglio, prezz.",
                        price: "7,50 €",
                        tags: ["carne", "piccante"]
                    },
                    {
                        name: "Crostone Caprese",
                        description: "Pane, pomodoro, mozzarella bufala.",
                        price: "7,50 €",
                        tags: ["vegetariana"]
                    },
                    {
                        name: "Crostone Squacquerone",
                        description: "Pane, squacquerone, prosc. crudo, pesca, aceto balsamico",
                        price: "7,50 €",
                        tags: ["carne"]
                    },
                    {
                        name: "Crostone Vegetariano",
                        description: "Pane, formaggi, verdure grigliate",
                        price: "7,50 €",
                        tags: ["vegetariana"]
                    }
                ]
            }
        ]
    },
];